<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>

    <a-card class="all-card-style ">

      <a-form-model ref="disease" :rules="sceneFormRules"  :model="model"  :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">

                <a-form-model-item label="姓名" class="ant-form-item2">
          <a-input v-model="model.cTaskName" placeholder="请输入" :rows="3" />
        </a-form-model-item>
                <a-form-model-item label="手机号" class="ant-form-item2">
          <a-input v-model="model.cTaskName" placeholder="请输入" :rows="3" />
        </a-form-model-item>



        <a-form-model-item label="性别" class="ant-form-item2">
          <a-input v-model="model.cVariety" placeholder="请输入" :rows="3" />
        </a-form-model-item>
         <a-form-model-item label="出生日期" class="ant-form-item2">
          <a-date-picker v-model="model.dOptDate" placeholder="请选择日期" />
        </a-form-model-item>




        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>
        </a-form-model-item>

      </a-form-model>


    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'

  export default {
    name: 'diseaseForm',
    components: {
      TitleCard
    },
    data() {
      return {
        titleMsg1: "生产",
        titleMsg2:'员工管理',
        titleMsg3:'员工管理-新增',
        titleMsg4:'员工管理-新增',
        model:{},
        cEntID:"",

        sceneFormRules:{


          cVariety: [
            { required: true, message: '请输入鱼类名称', trigger: 'blur' }
          ],
          cFeedKinds:[
            { required: true, message: '请选择饵料名称', trigger: 'blur' }
          ],
          dFeedQty:[
            { required: true, message: '请输入投饵量', trigger: 'blur' }
          ],
          cOptUser:[
            { required: true, message: '请输入操作人', trigger: 'blur' }
          ],
          投饵日期:[
            { required: true, message: '请选择投饵日期', trigger: 'change' }
          ]


        }
      }
    },
    mounted () {
      let that=this;
      if (that.$route.params.sceneId){
        that.model.sceneId=that.$route.params.sceneId;
      }
      if (that.$route.params.ID){
        that.model.ID=that.$route.params.ID;
        that.HandleDetail();
      }

      that.model.cSceneID=that.$store.getters.SCene.ID;
      that.model.cSceneName=that.$store.getters.SCene.cSceneName;


    },

    methods:{


      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('EntPlanTask/FindById/' + that.model.ID, null)

        if (res.data.code == "200") {
          that.model = res.data.obj.data;
        } else {

        }
      },
      async SaveForms () {
        let that = this;
        let form=that.$refs['disease'];
        form.validate(async valid => {

          if (valid) {
            let res = await that.$http.post('EntPlanTask/Save', that.model)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
              that.$router.push({name:'ScheduledTasksList'});
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>


